// Mock 訂單數據 - 作為前台和後台 API 的單一數據源
// 前後台需要的數據格式不一樣，此檔案以後台格式為主，前台另外依照需求轉換
// 前後台格式有以下差異
// - 命名：前台 camelCase，後台 snake_case
// - 結構：前台嵌套對象，後台平面結構
// - 型別：前台 isPaid 是字串，後台 is_paid 是數字
// - 欄位：後台有業務欄位（text, report, is_check），前台沒有，例如是否排版、出貨等

// 簡單的 1x1 透明 PNG Base64
const MOCK_IMAGE_BASE64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFhAJ/wlseKgAAAABJRU5ErkJggg==";

// Mock 用戶數據庫
export const mockUsers = [
  {
    id: 33,
    is_admin: 1,
    level: 1,
    account: "bbb",
    first_name: null,
    last_name: null,
    phone: null,
    email: null,
    country: "台灣",
    postal_code: null,
    address: null,
    created_at: "2019-10-07 20:51:53",
    updated_at: "2021-03-22 22:35:33",
    special_member: null,
  },
  {
    id: 34,
    is_admin: 0,
    level: 0,
    account: "user001",
    first_name: "美華",
    last_name: "李",
    phone: "0923456789",
    email: "li@example.com",
    country: "台灣",
    postal_code: "70001",
    address: "台南市中西區西門路二段263號",
    created_at: "2020-05-12 10:20:30",
    updated_at: "2024-12-15 09:15:00",
    special_member: null,
  },
  {
    id: 35,
    is_admin: 0,
    level: 1,
    account: "company999",
    first_name: "大同",
    last_name: "陳",
    phone: "0934567890",
    email: "chen@example.com",
    country: "台灣",
    postal_code: "40001",
    address: "台中市中區三民路二段50號",
    created_at: "2021-08-20 15:45:12",
    updated_at: "2024-12-22 15:20:00",
    special_member: {
      company_name: "大同企業有限公司",
      tax_id: "12345678",
    },
  },
];

// 訂單數據庫（使用全域變數以支援 POST 新增訂單）
export let mockOrders = [
  // 訂單 1：已付款、未出貨
  {
    id: "1",
    trade_no: "TRD20241220001",
    user_id: 33,
    sum: "15500",
    freight: "0",
    is_get: 1,
    get_at: "2025-12-25 10:30:00",
    is_paid: "1",
    paid_at: "2025-12-25 14:20:00",
    is_shipped: "0",
    shipped_at: null,
    is_check: 1,
    is_notify: 0,
    postal_trace_code: null,
    postal_cost: null,
    note: "請妥善包裝",
    notification: "電子郵件通知",
    send_way: "郵局宅配",
    first_name: null,
    last_name: null,
    full_name: "王小明",
    phone: "0912345678",
    email: "wang@example.com",
    country: "台灣",
    postal_code: "10001",
    address: "台北市中正區重慶南路1號",
    invoice_type: "個人",
    invoice_head: null,
    invoice_num: null,
    created_at: "2025-12-25 10:30:00",
    updated_at: "2025-12-25 14:20:00",
    deleted_at: null,
    report: [
      {
        updated_at: "2024-12-21 14:20:00",
        payment_bank_name: "台灣銀行",
        payment_amount: 15500,
        payment_account_last_five: "12345",
      },
    ],
    order_items: [
      {
        id: "1",
        shape: "方框",
        way: "I",
        style: "紀念車牌",
        length: 4.5,
        unit: "cm",
        weight: "0.10",
        image_url: MOCK_IMAGE_BASE64,
        amount: 2,
        accessory_name: "已含，附壓克力架美術包裝紙盒",
        accessory_price: 0,
        gold_fee: 4000,
        gold_price: 2000,
        engraving_content: {
          type: "commemorative_license_plate",
          content: {
            commemorativeLicensePlateImageCustom: "",
            commemorativeLicensePlateImageOption: "text",

            commemorativeLicensePlateImageText: "純文字",
            commemorativeLicensePlateNumber: "ABC-12345",
            commemorativeLicensePlateReverseText: "財源滾滾",
          },
        },
      },
      {
        id: "2",
        shape: "方框",
        way: "I",
        style: "紀念門牌",
        length: 4.5,
        unit: "cm",
        weight: "0.31",
        image_url: MOCK_IMAGE_BASE64,
        amount: 1,
        accessory_name: "已含，附壓克力架美術包裝紙盒",
        accessory_price: 0,
        gold_fee: 2500,
        gold_price: 1250,
        engraving_content: {
          type: "commemorative_doorplate",
          content: {
            commemorativeDoorplateImageOption: "tainan",
            commemorativeDoorplateImageCustom: "",
            commemorativeDoorplateDistrict: "中西區",
            commemorativeDoorplateRoadName:
              "西門路二段西門路二段西門路二段西門路二段",
            commemorativeDoorplateHouseNumber:
              "門牌號門牌號門牌號門牌號門牌號門牌號門牌",
            commemorativeDoorplateReverseText: "反面文字",
          },
        },
      },
      {
        id: "3",
        shape: "方框",
        way: "J",
        style: "紀念獎牌",
        length: 4.5,
        unit: "cm",
        weight: "0.31",
        image_url: MOCK_IMAGE_BASE64,
        amount: 1,
        accessory_name: "已含，附壓克力架美術包裝紙盒",
        accessory_price: 0,
        gold_fee: 2500,
        gold_price: 1250,
        engraving_content: {
          type: "commemorative_medal",
          content: {
            commemorativeMedalGreetingsAndName:
              "祝賀詞與名稱祝賀詞與名稱祝賀詞與名稱祝賀",
            commemorativeMedalGreetingMessage:
              "祝賀詞祝賀詞祝賀詞祝賀詞祝賀詞祝賀詞祝祝",
            commemorativeMedalGreetingImageOption: "cake",
            commemorativeMedalGreetingImageCustom: "",
            commemorativeMedalSenderName:
              "贈送人姓名贈送人姓名贈送人姓名贈送人姓名贈送人姓名贈送人",
          },
        },
      },
    ],
  },

  // 訂單 2：已付款、已出貨
  {
    id: "2",
    trade_no: "TRD20241215002",
    user_id: 34,
    sum: "8200",
    freight: "0",
    is_get: 1,
    get_at: "2024-12-15 09:15:00",
    is_paid: "1",
    paid_at: "2024-12-16 10:45:00",
    is_shipped: "1",
    shipped_at: "2024-12-18 16:30:00",
    is_check: 0,
    is_notify: 1,
    postal_trace_code: "1234567890123",
    postal_cost: null,
    note: "",
    notification: "電子郵件通知",
    send_way: "郵局宅配",
    first_name: null,
    last_name: null,
    full_name: "李美華",
    phone: "0923456789",
    email: "li@example.com",
    country: "台灣",
    postal_code: "70001",
    address: "台南市中西區西門路二段263號",
    invoice_type: "個人",
    invoice_head: null,
    invoice_num: null,
    created_at: "2024-12-15 09:15:00",
    updated_at: "2024-12-18 16:30:00",
    deleted_at: null,
    report: [
      {
        updated_at: "2024-12-16 10:45:00",
        payment_bank_name: "玉山銀行",
        payment_amount: 8200,
        payment_account_last_five: "67890",
      },
    ],
    order_items: [
      {
        id: "3",
        shape: "桃心",
        way: "A",
        style: "心心相印",
        length: 4,
        unit: "cm",
        weight: "8",
        image_url: MOCK_IMAGE_BASE64,
        amount: 1,
        accessory_name: "金色掛繩",
        accessory_price: 150,
        gold_fee: 4000,
        gold_price: 2000,
        engraving_content: {
          type: "default",
          content: {
            templeName: "龍山寺",
            godName: "觀世音菩薩",
            gift: "李美華 闔家",
            respect: "祈求平安",
          },
        },
      },
    ],
  },

  // 訂單 3：未付款、未出貨
  {
    id: "3",
    trade_no: "TRD20241222003",
    user_id: 35,
    sum: "12600",
    freight: "0",
    is_get: 1,
    get_at: "2024-12-22 15:20:00",
    is_paid: "0",
    paid_at: null,
    is_shipped: "0",
    shipped_at: null,
    is_check: 1,
    is_notify: 0,
    postal_trace_code: null,
    postal_cost: null,
    note: "請先確認排版再製作",
    notification: "電子郵件通知",
    send_way: "郵局宅配",
    first_name: null,
    last_name: null,
    full_name: "陳大同",
    phone: "0934567890",
    email: "chen@example.com",
    country: "台灣",
    postal_code: "40001",
    address: "台中市中區三民路二段50號",
    invoice_type: "公司",
    invoice_head: "大同企業有限公司",
    invoice_num: "12345678",
    created_at: "2024-12-22 15:20:00",
    updated_at: "2024-12-22 15:20:00",
    deleted_at: null,
    report: [],
    order_items: [
      {
        id: "4",
        shape: "元寶",
        way: "C",
        style: "招財進寶",
        length: 6,
        unit: "cm",
        weight: "12",
        image_url: MOCK_IMAGE_BASE64,
        amount: 1,
        accessory_name: "黃色掛繩",
        accessory_price: 100,
        gold_fee: 6000,
        gold_price: 3000,
        engraving_content: {
          type: "default",
          content: {
            templeName: "文昌宮",
            godName: "文昌帝君",
            gift: "陳大同",
            respect: "敬獻",
          },
        },
      },
    ],
  },
];

// 輔助函數：根據 ID 查找訂單
export function findOrderById(id) {
  return mockOrders.find((order) => order.id === id);
}

// 輔助函數：根據 ID 查找用戶
export function findUserById(userId) {
  return mockUsers.find((user) => user.id === userId);
}

// 輔助函數：新增訂單（供 POST 使用）
export function addMockOrder(orderData) {
  const newId = String(mockOrders.length + 1);
  const newTradeNo = `TRD${new Date()
    .toISOString()
    .slice(0, 10)
    .replace(/-/g, "")}${String(mockOrders.length + 1).padStart(3, "0")}`;

  const newOrder = {
    id: newId,
    trade_no: newTradeNo,
    full_name:
      orderData.full_name || `${orderData.lastName}${orderData.firstName}`,
    phone: orderData.phone || "",
    email: orderData.email || "",
    country: orderData.country || "台灣",
    postal_code: orderData.postalCode || orderData.postal_code || "",
    address: orderData.address || "",
    send_way: orderData.sendWay || orderData.send_way || "郵局宅配",
    invoice_type: orderData.invoiceType || orderData.invoice_type || "個人",
    invoice_head: orderData.invoiceHead || orderData.invoice_head || "",
    invoice_num: orderData.invoiceNum || orderData.invoice_num || "",
    created_at: new Date().toISOString().replace("T", " ").slice(0, 19),
    shipped_at: null,
    is_paid: 0,
    is_shipped: 0,
    is_check: orderData.is_check || 0,
    is_notify: 0,
    postal_trace_code: null,
    postal_cost: 100,
    sum: calculateOrderSum(orderData.product || orderData.order_items || []),
    note: orderData.note || "",
    report: [],
    order_items: (orderData.product || orderData.order_items || []).map(
      (item, index) => ({
        id: String(mockOrders.length * 10 + index + 1),
        shape: item.shape || "",
        way: item.way || item.size?.way || "A",
        style: item.style || "",
        length: item.length || item.size?.length || 5,
        unit: item.unit || item.size?.unit || "cm",
        weight: item.weight || item.size?.weight || "10",
        image_url: item.imageUrl || item.image_url || MOCK_IMAGE_BASE64,
        amount: item.amount || 1,
        accessory_name: item.accessory_name || item.accessory || null,
        accessory_price: item.accessory_price || 0,
        gold_fee: item.gold_fee || 5000,
        gold_price: item.gold_price || 2500,
        engraving_content: item.engraving_content || {
          type: "default",
          content: {
            templeName: "",
            godName: "",
            gift: "",
            respect: "",
          },
        },
      })
    ),
  };

  mockOrders.push(newOrder);
  return newOrder;
}

// 輔助函數：計算訂單總金額
function calculateOrderSum(items) {
  return items.reduce((sum, item) => {
    const itemTotal = (item.gold_fee || 5000) + (item.accessory_price || 0);
    return sum + itemTotal * (item.amount || 1);
  }, 100); // 100 是運費
}
